import styled, { css, keyframes } from 'styled-components'
import media from 'styled-media-query'

const FadeInDrownAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const FadeInRightAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateX(8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`

export const HelperSidebar = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.secondary};
    position: fixed;
    right: 0;
    bottom: 0;
    height: calc(100vh - 80px);
    width: 340px;
    z-index: 3;
    overflow-y: scroll;
    animation: ${FadeInRightAnimation} ${theme.transition.slowly};

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.primary};
      border-radius: 10px;
    }

    ${media.lessThan('small')`
      width: 100%;
    `}
  `}
`

export const SidebarContent = styled.div`
  ${({ theme }) => css`
    width: 100%;
    color: ${theme.colors.white};
    font-family: ${theme.font.montserrat};
    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.semiBold};
    background: ${theme.colors.primary};
    border-radius: 0 ${theme.border.smallRadius} ${theme.border.smallRadius} 0;
    margin-top: 8px;
    margin-bottom: 8px;

    .sidebar-content-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px;
      cursor: pointer;

      svg {
        transform: rotate(180deg);
      }

      :hover {
        filter: brightness(0.8);
      }
    }

    &.dropActive {
      background: ${theme.colors.primary};

      .sidebar-content-dropdown {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid ${theme.colors.xxlightGray};

        div {
          color: ${theme.colors.primary};
        }

        span {
          font-family: Arial, Helvetica, sans-serif;
          color: #000;
        }
      }

      .sidebar-content-title {
        svg {
          transform: rotate(270deg);
        }
      }
    }
  `}
`

export const SidebarItemContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: end;

    > button {
      background: transparent;
      color: ${theme.colors.white};
      font-size: ${theme.font.sizes.medium};
      cursor: pointer;
      align-items: flex-end;
      margin-top: 10px;
      margin-right: 8px;
      transition: ${theme.transition.default};

      &:hover {
        filter: brightness(0.9);
      }
    }
  `}
`

export const CloseButton = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: end;
    margin-bottom: 20px;

    > button {
      background: transparent;
      color: ${theme.colors.white};
      font-size: ${theme.font.sizes.medium};
      cursor: pointer;
      align-items: flex-end;
      margin-top: 10px;
      transition: ${theme.transition.default};

      &:hover {
        filter: brightness(0.9);
      }
    }
  `}
`

export const SidebarContentDropdown = styled.div`
  ${({ theme }) => css`
    display: none;
    padding: 0 18px;
    background: ${theme.colors.white};
    color: ${theme.colors.secondary};
    word-break: break-word;
    animation: ${FadeInDrownAnimation} ${theme.transition.default};

    > div {
      margin: 8px 0;
      color: ${theme.colors.gray};

      span {
        color: ${theme.colors.secondary};
      }
    }
  `}
`

export const HelpContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: fixed;
    background: transparent;
    top: 160px;
    right: 8px;
    transition: all ${theme.transition.default};
    cursor: pointer;
    z-index: 2;

    > span {
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.semiBold};
    }

    &:hover {
      color: ${theme.colors.primary};
    }

    ${media.lessThan('small')`
      right: 0;
      bottom: 8px;

      span {
        display: none;
      }
    `}
  `}
`

export const HelpButton = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.secondary};
    border: none;
    cursor: pointer;
    padding: 14px;
    border-radius: 50%;
    z-index: 2;
    transition: all ${theme.transition.default};

    > svg {
      width: 30px;
      height: 30px;
      margin: 6px 0 0 2px;
    }

    &:hover {
      background: ${theme.colors.primary};
    }

    ${media.lessThan('small')`
      padding: 6px;
    `}
  `}
`
